import { PrecompraService } from "src/app/services/precompra.service";

import { Subscriber } from "rxjs";
import { ModulomxService } from "./../../services/modulomx.service";
import { EntransitoService } from "./../../services/entransito.service";
import { MovimientospgosService } from "./../../services/movimientospgos.service";

import { Usuario } from "./../../models/usuario";


import { UsuarioService } from "./../../services/usuario/usuario.service";
import { TablasolicitanteService } from "./../../services/tablasolicitante/tablasolicitante.service";

import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Solicitante } from "./../../models/solictante";
import { Pescador } from "./../../models/pescador";

import { TablapescadoresService } from "src/app/services/tablapescador/tablapescadores.service";
import { FormGroup, FormControl } from "@angular/forms";
import { SubirarchivoService } from "./../../services/subirarchivo/subirarchivo.service";
import { FileService } from "src/app/services/file.service";
import { saveAs } from "file-saver";
import { SolicitanteService } from "../../services/solicitante/solicitante.service";
import Swal from "sweetalert2";
import { EmailService } from "src/app/services/email/email.service";
import * as moment from "moment";
import { Router, RouterLink } from "@angular/router";


import { MatDialog, MatTabChangeEvent } from "@angular/material";
import { CapturaComponent } from "../usuario/captura/captura.component";
import { EditorComponent } from "../editor/editor.component";
import { Color } from "jspdf-autotable";

import { NgxSpinnerService } from "ngx-spinner";
import { NotificationsService } from "angular2-notifications";
import { SocketioService } from "src/app/services/socketio.service";
import { Colorenglon } from "src/app/models/color";
import { Lote } from "src/app/models/lote";
import { LoteService } from "src/app/services/lote.service";
import { async } from "@angular/core/testing";
import { ReciboxeventopreComponent } from "../reciboxeventopre/reciboxeventopre.component";
import { URL_SERVICIOS } from "src/app/config/config";


@Component({
  selector: "app-tabla",
  templateUrl: "./tabla.component.html",
  styleUrls: ["./tabla.component.css"],
})
export class TablaComponent implements OnInit {
  listadolote: Lote[] = [];
  listasolicitantes: Solicitante[];
  listaPescadores: Pescador[];
  idsolicitante = "";
  claveusuario: string;
  solicitudhtml = "";
  tipopagos = '';
  entransito = 0;
  enviados: number;
  successMessage: any;
  titulosuccessMessage: "";
  contadorsolicitudes = 0;
  filtroPost = "";
  colorpersonal = "";
  bprecompra = false;
  cveclientesolicitante = "";
  numeropaypal = "";
  tipolic = "";
  nombrearchivoxls = "";
  botonrefreshtexto = "";
  usuariolistado: Usuario[] = [];
  nombrebot = "";
  txtstatusmovimiento = "En espera";
  refrescaSolicitudes = false;

  licdevueltas = 0;
  cveunicasmx = "";

  registrovienede = "";
  muestrabotonimprimirrecibo = false;

  rotulabotonLicencia = "Archivo Adjunto: Ninguno";
  rotulabotonLicenciaexp = "Subir Licencia-Exp";

  minutos: number = 0;
  segundos: number = 0;
  colorCheck = false;

  displayhistorial= false;

  

  // esta variable rotula el bootn de subur licencias

  // botonFinalizadeshabilitado = false;
  // const locale = 'en-US';

  txtSolicitante: string;
  txtemail: string;
  txtOrdenSolicitud: string;
  txtcantidaSolicitada: string;
  txtsolicitado: number;
  txttotalPagado: any;
  grantotalusuario: number;
  archivoSubir: File;
  loteasignado: number;

  isDivVisible: boolean;

  extensionArchivo: string;
  nombreArchivo: string;

  showExcel: boolean;
  showEmail: boolean;
  idusuarioActivo: string; // esta variable contiene el id del usuario actual
  showPDF: boolean;
  idsolicitudActual: string; // esta variable contine le id ddel la "solicitud" actual
  procederCaptura: boolean; // esta variable es la bandera para colorear los renglones de procesar la inforamcion semafor verde y rojo
  nombreArchivoPDF: string;
  subjettxt: string;
  cantidadpagada: number;
  solicitantetxt: string;
  apellidos: string;
  idempresa: string;

  ciudadsolicitante: string;
  tipoLicenciatxt: string;
  estadotxt: string;
  fechasolicitudtxt: string;

  cambiacolorcuadro = "gris";
  cambiacolordisponiblilidad = "gris";

  formaLectura: FormGroup;
  inventario = 0;
  disponibilidad = 0;
  idultimoinventario: string;
  mysmsg: any;
  statusbots: string;
  botsActivos=true;

  lisennumerofolio: string;
  lisencolor: string;
  precomprasrealizadas = 0;
  es_usuariosportmx = false;
  variableusuario = "";
  numeroidusuariomx = "";
  identificadorpescador: string;
  sususuarios: any;
  aliasusuario: string;

  nuevovalorcronometro: Number =1;

  fillColor="#5f8d51";

  idempresaseleccionada="";

  @ViewChild("bots", { static: true }) bots: ElementRef;

  // @ViewChild('solicitantetxt', { static: true }) solicitantetxt: ElementRef;
  // @ViewChild('ciudadsolicitante', { static: true }) ciudadsolicitante: ElementRef;
  // @ViewChild('tipoLicenciatxt', { static: true }) tipoLicenciatxt: ElementRef;
  // @ViewChild('apellidos', { static: true }) apellidos: ElementRef;

  // @ViewChild('estadotxt', { static: true }) estadotxt: ElementRef;
  // @ViewChild('fechasolicitudtxt', { static: true }) fechasolicitudtxt: ElementRef;

  constructor(
    public tablaSolicitanteService: TablasolicitanteService,
    public tablaPescadoresService: TablapescadoresService,
    private subirArchivoService: SubirarchivoService,
    private solicitanteService: SolicitanteService,
    private _fileService: FileService,
    private emailService: EmailService,
    private usuarioservice: UsuarioService,
    public router: Router,
    private dialog: MatDialog,
    private socketService: SocketioService,
    private precompraService: PrecompraService,
    private movimientopgoService: MovimientospgosService,
    private entransitoService: EntransitoService,
    private spinner: NgxSpinnerService,
    public modulomxService: ModulomxService,
    private notificationsService: NotificationsService,
    private loteService: LoteService,
    
  ) { }

   ngOnInit() {
    
   

    this.botonrefreshtexto = "Refrescar";
    this.variableusuario = localStorage.getItem("userol");

    if (this.variableusuario === "USER_SPORTFISHING") {
      this.es_usuariosportmx = true;
    }

    this.numeroidusuariomx = localStorage.getItem("iduser");

    this.statusbots = "Bots";

    this.socketService.listen("solicitalicencia").subscribe((data) => {
      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);

      this.titulosuccessMessage = obj.de;
      this.successMessage = obj.cuerpo;
      this.Notificacion(this.titulosuccessMessage, this.successMessage);
      this.playAudio();
    });

    this.socketService.listen("colorearenglon").subscribe((data) => {
      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);

      this.lisencolor = obj.color;
      this.lisennumerofolio = obj.numerofolio;
      this.colorearenglon(this.lisennumerofolio, this.lisencolor);
    });



    this.socketService.listen("enlineaWeb").subscribe((data) => {
      alert ("demo");

      
    });


    this.socketService.listen("usuarios_sportfishing").subscribe((data) => {
      this.listandobotsinicialmente();

      
    });




    this.idultimoinventario = "";
    this.isDivVisible = true;
    this.aliasusuario = this.usuarioservice.alias;
    // this.socketService.setupSocketConnection();
     this.muestrasolicitantesquepagaron(this.aliasusuario);
    // this.getMessages().subscribe ( msg => {

    //       this.muestrasolicitantesquepagaron();
    //     });

    this.txtSolicitante = "";
    this.txtemail = "Correo electronico de la Empresa";
    this.txtOrdenSolicitud = "";
    this.nombreArchivo = "";
    this.showExcel = false;
    this.showPDF = false;
    this.showEmail = false;
    this.subjettxt = "";
    this.enviados = 0;

    this.idusuarioActivo = localStorage.getItem("id");
    this.colorpersonal = this.usuarioservice.colorpersonal;
    this.idempresa = this.usuarioservice.idempresa;


     this.listandobotsinicialmente();
  }

  ngOnDestroy() {
    this.sususuarios.unsubscribe();
  }

  refrecarBots() {
    // this.Listadousuarios();
  }


  devuelvelicencias(
    numero_orden: string,
    cantidalicencias: string,
    idsmx: string,
    texto: string,
    identificadorpescador: string,
    observaciones
  ) {
    this.movimientopgoService
      .devolucioneslicencias(
        numero_orden,
        cantidalicencias,
        idsmx,
        texto,
        identificadorpescador,
        observaciones
      )
      .subscribe((respuesta) => {
        console.log(respuesta);
        
       /// this.txtcantidaSolicitada = respuesta['pescadoractualizado'].cantidad + "-" + respuesta['pescadoractualizado'].apellido;
        this.txtcantidaSolicitada = respuesta['pescadoractualizado'].tipolicencia;
        this.disponibilidad = Number(this.disponibilidad) + Number(cantidalicencias);
       // this.entransito = Number(this.entransito) - Number(cantidalicencias);

        const payload = {
          para: this.txtOrdenSolicitud,
         // archivopdf: this.nombreArchivoPDF,
        };
        this.socketService.emit("muestrapdf", payload);

      });
  }







  devuelvelicenciasagencia(
    numero_orden: string,
    cantidalicencias: string,
    idsmx: string,
    texto: string,
    identificadorpescador: string,
    observaciones: string
  ) {
    this.movimientopgoService
      .devolucioneslicenciasagencias(
        numero_orden,
        cantidalicencias,
        idsmx,
        texto,
        identificadorpescador,
        observaciones
      )
      .subscribe((respuesta) => {
        console.log(respuesta);
        
        /// this.txtcantidaSolicitada = respuesta['pescadoractualizado'].cantidad + "-" + respuesta['pescadoractualizado'].apellido;
         this.txtcantidaSolicitada = respuesta['pescadoractualizado'].tipolicencia;
         this.disponibilidad = Number(this.disponibilidad) + Number(cantidalicencias);
        // this.entransito = Number(this.entransito) - Number(cantidalicencias);
 
         const payload = {
           para: this.txtOrdenSolicitud,
          // archivopdf: this.nombreArchivoPDF,
         };
         this.socketService.emit("muestrapdf", payload);
      });
  }

  devolverpermisos() {
    var testVar = this.txtSolicitante;

    Swal.fire({
      title: "<strong>" + testVar + "</strong>",
      icon: "info",
      text: "Desea hacerle una devolucion de Licencias? ",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          html:
            'Cantidad a Devolver: <input id="swal-input1" class="swal2-input">' +
            'Motivo de la devolucion <input id="swal-input2" class="swal2-input">',

          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          confirmButtonText: "Devolver",
          showLoaderOnConfirm: true,
          preConfirm: (login) => {
            return fetch(`//api.github.com/users/${login}`)
              .then((response) => {
                if (!response.ok) {
                  throw new Error(response.statusText);
                }
                return response.json();
              })
              .catch((error) => {
                Swal.showValidationMessage(`Request failed: ${error}`);
              });
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            let cantidaddevolver = (<HTMLInputElement>document.getElementById('swal-input1')).value;
            let observaciones = (<HTMLInputElement>document.getElementById('swal-input2')).value;

            

            let numeros: string[] = this.txtcantidaSolicitada.match(/\d+/g);
            
            if (Number(cantidaddevolver) <= (Number(numeros))) {

            


            if (this.registrovienede == "P-AGENCIAS") {
              this.devuelvelicenciasagencia(
                this.txtOrdenSolicitud,
                cantidaddevolver,
                this.numeroidusuariomx,
                "devolucion de licencias",
                this.identificadorpescador,
                observaciones
              )
            } else {
              this.devuelvelicencias(
                this.txtOrdenSolicitud,
                cantidaddevolver,
                this.numeroidusuariomx,
                "devolucion de licencias",
                this.identificadorpescador,
                observaciones
              );
            }

}

          }
        });
      }
    });
  }

 
  async Listadousuarios() {
    this.sususuarios = await this.usuarioservice
      .listadototalusuariosxempresa(this.idempresa)
      .subscribe((resp) => {
        let prom2 = new Promise<void>((resolve) => {
          this.usuariolistado = resp;
          setTimeout(() => {
            resolve();
          }, 1500);
        });

        prom2.then(() => {
          alert("recarga de bots");
        });
      });
  }

  async listandobotsinicialmente() {
    this.sususuarios = await this.usuarioservice
      .listadototalusuariosxempresa(this.idempresa)
      .subscribe((resp) => {
        this.usuariolistado = resp;
      });
  }

  playAudio() {
    const usuarioGuardado = localStorage.getItem("usuario");
    const usuario = usuarioGuardado ? JSON.parse(usuarioGuardado) : null;
    const sonidoPersonal = usuario && usuario.sonidoNotificacion;
    const sonidoPredeterminado = "/assets/sound/notification.mp3";
    const audio = new Audio(sonidoPersonal ? URL_SERVICIOS + "/" + sonidoPersonal : sonidoPredeterminado);

    audio.onerror = () => {
      const respaldo = new Audio(sonidoPredeterminado);
      respaldo.play().catch(() => {});
    };

    audio.play().catch(() => {});
  }

  escuchasocket() { }

  usermxapagado(listado: Usuario) {
    let nombrebot = listado.alias;
    this.usuariolistado.find((item) => { });
  }

  disponibilidadlotes() {
    // la idea es accesar al primer registro unicamente para conocer el valor
  }

  asignarlote(usuario: Usuario) {
    // this.spinner.show();
    // this.statusbots = "Esperando..."

    // let cuentalinealote = 1
    // for (let numero of this.listadolote){
    //   if (cuentalinealote = 1) {
    //     this.listadolote[0].
    //   } else {
    //     if (cuentalinealote = 2) {

    //       return;
    //     }
    //   }

    //   console.log(numero);
    // }

    let lotesdisponiblesEmpresas = this.listadolote.length;


    // let valordescripcion = this.txtcantidaSolicitada; // este vlor lo toma de los cuadros de la tabla -descripcion solicitus-
    // let posicionprimercaracter = valordescripcion.indexOf("-");  // de ese valor busca el guion para poder separa el numero dle texto
    // let valornumericodisponible = (this.listadolote[0].disponible) - Number(
    //   valordescripcion.slice(0, posicionprimercaracter)
    // );  // y con este procedimienot resta la disponibilidad actual con la cantidad solicitada de manera anticipada
    // let idlotes = this.listadolote[0]._id;


    // if (valornumericodisponible >= 0) {
    // this.asignausuariosylotes(usuario.alias, usuario._id,valornumericodisponible,idlotes);
    this.asignausuariosylotes(usuario.alias, usuario._id);

    // } else {
    //   if (valornumericodisponible < 0){
    //     if (this.listadolote[0].status){ // este queire decir que esta ocupado haciendo le proceso y como no cabe debera pasar al siguiente lote
    //         console.log ('no disponible');

    //     } else {

    //       console.log ('disponible');
    //       this.asignausuariosylotes(usuario.alias, usuario._id,valornumericodisponible, idlotes);




    //     }

    //   }
    // }

  }


  asignausuariosylotes(aliasusuario: string, identificadorusuario) {
    this.nombrebot = aliasusuario;
    this.usuarioservice
      .actualizastatus(identificadorusuario, "busy", this.txtOrdenSolicitud)
      .subscribe((resp) => {
        let prom1 = new Promise<void>((resolve) => {
          this.usuariolistado = resp.usuario;
          this.listasolicitantes = resp.solicitante;

          this.statusbots = "Bots";
          this.enviarnotificaciondecompra(
            "SMXBOT, asigno trabajo a " + this.nombrebot
          );
          // this.spinner.hide();
          setTimeout(() => {
            resolve();
          }, 1500);
        });

        prom1.then(() => {
          alert("asignacion Correcta");
        });

        // this.modulomxService.mensajeadquierelicencias(this.idempresa, 'compralicencias');
      });
  }

  // asignausuariosylotes(aliasusuario: string,identificadorusuario, nuevodisponible: number, idlote: string ){
  //   this.nombrebot = aliasusuario;
  //   this.usuarioservice
  //      .actualizastatus(identificadorusuario, "busy", this.txtOrdenSolicitud,nuevodisponible,idlote)
  //     .subscribe((resp) => {
  //       let prom1 = new Promise<void>((resolve) => {
  //         this.usuariolistado = resp.usuario;
  //         this.listasolicitantes = resp.solicitante;

  //         this.statusbots = "Bots";
  //         this.enviarnotificaciondecompra(
  //           "SMXBOT, asigno trabajo a " + this.nombrebot
  //         );
  //         // this.spinner.hide();
  //         setTimeout(() => {
  //           resolve();
  //         }, 1500);
  //       });

  //       prom1.then(() => {
  //         alert("asignacion Correcta");
  //       });

  //       // this.modulomxService.mensajeadquierelicencias(this.idempresa, 'compralicencias');
  //     });
  // }

  enviarnotificaciondecompra(mensaje: string) {
    // socket envia accion
    this.modulomxService.mensajesolicitudlicencias("adminBot", mensaje);
  }


  cambiastatusbot(info: Usuario, status) {
    if (info.status == "off") {
      status = "On"
    } else {
      if (info.status == "free") {
        status = "off"
      } else {
        status = "off"
      }
    }
    this.usuarioservice
      .cambiastatus(info._id, status)
      .subscribe((resp) => {
        this.usuariolistado = resp.usuario;

        // this.modulomxService.mensajeadquierelicencias(this.idempresa, 'compralicencias');
      });

  }

  tareafinalizada(cveus: string, status) {
    // if (status == "off") {
    //  status = "On";
    //    }

    this.usuarioservice
      .actualizastatustarea(cveus, status)
      .subscribe((resp) => {
        this.usuariolistado = resp.usuario;

        // this.modulomxService.mensajeadquierelicencias(this.idempresa, 'compralicencias');
      });
  }

  // 982 1242016

  // edgar

  muestrasolicitantesquepagaron(usuarioinicial: string) {
    this.txtstatusmovimiento = "En espera";

    this.spinner.show();

    let promesa = new Promise<void>((resolve, reject) => {
        // this.subjettxt="";
        // this.nombrearchivoxls="";
        // this.nombreArchivoPDF="";
        // this.txtOrdenSolicitud="";
        // this.txtSolicitante="";
        // this.txtcantidaSolicitada="";
        // this.txttotalPagado="";
        // this.txtemail="";
        // this.nombreArchivo="";


      
      setTimeout(() => {
         this.tablaSolicitanteService.getLicencias(usuarioinicial).subscribe(
           (listado) => {
             this.listasolicitantes = listado;
           },
           (err) => console.log(err)
         );

        resolve();
      }, 100);
    });

    promesa.then(
      () => {
        this.spinner.hide();
        // this.txtstatusmovimiento = "Listo";
        if (this.es_usuariosportmx && this.refrescaSolicitudes) {
          this.refrescaSolicitudes = false;
          alert("Informacion Desplegada");
        }
      },
      (error) => {
        this.spinner.hide();
        console.error("onRejected function called: " + error.message);
      }
    );
  }

//  despliegalistado(listado: Solicitante) {
//    alert("hola");
//  }




  muestraPescadoreslista(listado: Solicitante) {
    this.spinner.show();
    this.txtstatusmovimiento = "Procesando...";

    let promesa2 = new Promise((resolve, reject) => {

      this.idsolicitudActual = listado._id;
      localStorage.setItem('idempresaprepago', listado.idempresa);
      this.idempresaseleccionada=listado.idempresa;


      this.idsolicitante = listado.idusuario;

      // alert (this.idultimoinventario );

      this.txtSolicitante = listado.nombre;

      // console.log (this.txtSolicitante );
      if (listado.emailbarco == null || listado.emailbarco == undefined || listado.emailbarco == '') {
        this.txtemail = listado.email;
      } else {
        this.txtemail = listado.email + "," + listado.emailbarco;
      }



      this.txtOrdenSolicitud = listado.numeroperacion;
      this.nombreArchivo = listado.nombrearchivo;
      this.nombreArchivoPDF = listado.nombrearchivopdf;
      this.subjettxt = listado.nombrearchivopdf;
      this.solicitudhtml = listado.solicitudhtml;
      this.registrovienede = listado.vienedemodulo;

      // esta opcion desaparace y aparece el boton que imprimme
      //  exclusivamente el compromabnte de pagos por evento
      if (this.registrovienede.includes("LANDING")) {
        this.muestrabotonimprimirrecibo = true;
      } else {
        this.muestrabotonimprimirrecibo = false;
      }
      //**************************************** */

      this.nombrearchivoxls = listado.nombrearchivo;
      this.cveunicasmx = listado.usermx;
      this.loteasignado = listado.loteasignado;
      this.tipopagos = listado.numeroconfirmacion;
      this.txtcantidaSolicitada = "";
      this.txtsolicitado = 0;
      this.txttotalPagado = "";



      console.log("nombre archivo", this.solicitudhtml);
      this.showPDF = false;
      this.showExcel = false;

      //    if ( this.nombreArchivo === 'null' || this.nombreArchivo === 'undefined' || this.nombreArchivo === 'null') {
      // this.showExcel = false;
      //   } else {
      // this.showExcel = true;
      //   }

      console.log(this.solicitudhtml);

      if (this.solicitudhtml === undefined || this.solicitudhtml === null) {
        this.showExcel = false;
      } else {
        this.showExcel = true;
      }

      // console.log ('nombre pdf pfd' + this.nombreArchivoPDF );
      if (
        this.nombreArchivoPDF === "null" ||
        this.nombreArchivoPDF === "undefined" ||
        this.nombreArchivoPDF === "No Generado"
      ) {
        this.showPDF = false;
      } else {
        this.showPDF = true;
      }

      if (
        this.nombreArchivo === "null" ||
        this.nombreArchivo === "undefined" ||
        this.nombreArchivo === "No Generado"
      ) {
        this.showExcel = false;
      } else {
        this.showExcel = true;
      }

      // this.colorearenglon(listado.numeroperacion,'#C71585');










      this.tablaPescadoresService.getpescadores(listado._id).subscribe(
        (listadoPescadores) => {
          this.listaPescadores = listadoPescadores;

          this.muestradatosPescadores(this.listaPescadores[0]);
          this.txtcantidaSolicitada = this.listaPescadores[0].tipolicencia;


          if (this.registrovienede == "P-AGENCIAS" || this.registrovienede == "PRECOMPRA") {

            this.muestralotedempresagencia(listado.idempresa);

          } else {


            // if (this.txtcantidaSolicitada.includes("Dia") || this.txtcantidaSolicitada.includes("Day")) {
            // le ootye ha sido asiganado
            this.muestralotelanding(listado.idempresa, this.loteasignado);
            //  } else {
            //  if (this.txtcantidaSolicitada != "") {
            // aqui es cundo no teine lotes asignado y busca el lote dependiendo la stustus
            // semannaa año excursion
            //     this.muestralotedempresavarios(this.txtcantidaSolicitada);
            //   }
            //     }


          }

        },
        (err) => console.log(err)
      );


      setTimeout(() => {






        resolve("fin");
      }, 100);
    });

    promesa2.then((mensaje: string) => {


      if (listado.deprecompra) {
        if (this.registrovienede === "P-AGENCIAS") {
          // esta opcin se aplicara a aquellos regiustros que viene de las agencias
          this.bprecompra = true;
          this.isDivVisible = false;
          this.ultimaprecompraagencia(listado.idempresa, this.txtcantidaSolicitada);
          this.licenciaentransitoagencia(listado.idempresa, this.tipolic);
        } else {
          this.bprecompra = true;
          this.isDivVisible = false;
          this.ultimaprecompra(listado.idempresa);
          this.licenciaentransito(listado.idempresa);
        }

      } else {
        this.bprecompra = false;
        this.isDivVisible = true;
      }





      this.spinner.hide();
      this.txtstatusmovimiento = "Listo";
      // alert ("datos completados")
    },
      (error) => {
        this.spinner.hide();
        console.error("onRejected function called: " + error.message);
      }
    );
  }

  deshabilitarlote() { }

  checainventariosprecompras() { }

  rectificapropiedadvalor(posicion: string, color: string) {
    // alert (posicion);
    let element = document.getElementById(posicion);
    return true;

    // if ( element.style.backgroundColor === '') {
    //   return true;
    // } else {
    //   if (element.style.backgroundColor !== color ){
    //     alert ('es otro usuario');
    //     return false;
    //   }

    // }
  }

  colorearenglon(posicion: string, color: string) {
    // alert (posicion);
    let element = document.getElementById(posicion);
    element.style.backgroundColor = color;
  }

  muestradatosPescadores(listadopescadores: Pescador) {
    this.solicitantetxt = listadopescadores.nombre;
    this.txtcantidaSolicitada = listadopescadores.tipolicencia;
    this.txtsolicitado = listadopescadores.cantidad;
    this.apellidos = listadopescadores.apellido;
    this.txttotalPagado = listadopescadores.costolicencia;

    this.identificadorpescador = listadopescadores._id;

    this.ciudadsolicitante = listadopescadores.ciudad;
    this.tipoLicenciatxt = listadopescadores.tipolicencia;
    this.estadotxt = listadopescadores.estado;
    this.licdevueltas = listadopescadores.licdevueltas;

    if (this.licdevueltas > 0) {
      this.colorCheck = true;
    } else {
      this.colorCheck = false;
    }

    // this.cantidadpagada = listadopescadores.costolicencia;
    // this.txttotalPagado = listadopescadores.costolicencia;
    // this.fechasolicitudtxt.nativeElement.value = moment(listadopescadores.fechainiciopesca).format('DD-MM-YYYY') ;

    const d = new Date(listadopescadores.fechainiciopesca);
    d.setMinutes(d.getMinutes() + d.getTimezoneOffset());

    this.fechasolicitudtxt = moment(d).format("DD-MMM-YYYY");
  }

  SeleccionImagen(event) {
    //  alert ("archivo seleccionado");
    const file = event.target.files[0];

    this.archivoSubir = file;
    const id = "archivo";
    // const id = this.nombrearchivoCreado;
    const vnombreArchivofile = file.name;

    const extensionfile = vnombreArchivofile.indexOf("pdf");
    console.log(extensionfile);

    if (extensionfile === 0) {
      this.extensionArchivo = "pdf";
    } else {
      this.extensionArchivo = "pdf";
    }

    //  var nombreArchivoSeleccionado = string(this.archivoSubir;

    this.subjettxt = vnombreArchivofile;
    this.rotulabotonLicencia = vnombreArchivofile;
    console.log("nombre dle nuevo archivo", this.rotulabotonLicencia);

    this.subirArchivoService
      .subirArchivo(this.archivoSubir, "download", id)
      .then((resp) => {
        // console.log("respuesta arcchivo", resp);

        this.showPDF = true;
        //   console.log ('mensaje de archivo2 ', vnombreArchivofile);
        this.nombreArchivoPDF = vnombreArchivofile;

        this.actualizaPDF(vnombreArchivofile);
      })
      .catch((resp) => {
        console.log("esta es una rexteespuesta", resp);
      });
  }



  // reimprimirrecibos(identificador: string, fechadeimpresion: string) {
  reimprimirrecibos() {


    const dialogRef = this.dialog.open(ReciboxeventopreComponent, {
      panelClass: 'mensaje', width: '1000px',
      disableClose: true,
      data: {

        idempresa: this.idempresa,
        idsolicitante: this.idsolicitudActual,

      }
    });




  }






  SeleccionXLS(event) {
    //  alert ("archivo seleccionado");
    const file = event.target.files[0];

    this.archivoSubir = file;
    const id = "archivo";
    // const id = this.nombrearchivoCreado;
    const vnombreArchivofile = file.name;

    const extensionfile = vnombreArchivofile.indexOf("xls");
    console.log(extensionfile);

    if (extensionfile === 0) {
      this.extensionArchivo = "xls";
    } else {
      this.extensionArchivo = "xls";
    }

    //  var nombreArchivoSeleccionado = string(this.archivoSubir;

    // this.nombrearchivoxls = vnombreArchivofile;
    //this.rotulabotonLicencia = vnombreArchivofile;
    // console.log("nombre dle nuevo archivo", this.rotulabotonLicencia);

    this.subirArchivoService
      .subirArchivo(this.archivoSubir, "download", id)
      .then((resp) => {
       // console.log("respuesta arcchivo", resp);

        // this.showPDF = true;
        //   console.log ('mensaje de archivo2 ', vnombreArchivofile);
        // this.nombrearchivoxls = vnombreArchivofile;

        // this.actualizaPDF(vnombreArchivofile);
      })
      .catch((resp) => {
        console.log("esta es una rexteespuesta", resp);
      });
  }

  Notificacion(titulo, message) {
    this.contadorsolicitudes = this.contadorsolicitudes + 1;
    this.notificationsService.success(titulo, message, {
      position: ["botton", "right"],
      timeOut: 5000,
      animate: "fade",
      showProgressBar: true,
    });
  }

  download() {
    const filename = this.nombreArchivo;
    console.log("nombre dle archivo filename", filename);

    this._fileService.downloadFileExcel(filename).subscribe(
      (data) => saveAs(data, filename),
      (error) => console.error(error)
    );

    //    const dialogRef = this.dialog.open(EditorComponent, { width:'1500px', disableClose: true,
    //    data: {
    //      identificador: this.solicitudhtml
    //    }
    //  });

    //            dialogRef.afterClosed().subscribe(
    //             data => this.solicitudhtml = data
    //         );
  }

  downloadpdf() {
    const filename = this.nombreArchivoPDF;

    this._fileService.downloadFilePDF(filename).subscribe(
      (data) => saveAs(data, filename),
      (error) => console.error(error)
    );

    //    const dialogRef = this.dialog.open(EditorComponent, { width:'1500px', disableClose: true,
    //    data: {
    //      identificador: this.solicitudhtml
    //    }
    //  });

    //            dialogRef.afterClosed().subscribe(
    //             data => this.solicitudhtml = data
    //         );
  }

  finalizarProceso() {
    //  if (this.showPDF) {
    this.solicitanteService
      .solicitudFinalizada(this.idsolicitudActual)
      .subscribe((res) => {
        this.txtOrdenSolicitud = "";
        this.txtSolicitante = "";
        this.txtemail = "";
        this.showExcel = false;
        this.showPDF = false;

        this.muestrasolicitantesquepagaron(this.aliasusuario);
      });

    //  } else {
    //   Swal.fire('Oops...', 'Creo que olvido subir el archivo', 'error');
    //  }
  }


 


  mostrarinfoclientes() {
    //prepago
    
    if (this.registrovienede === "PRECOMPRA") {
      this.router.navigate(['../prepago'],{queryParams: { order: this.idempresaseleccionada }});
    } else if (this.registrovienede === "P-AGENCIAS") {
      this.router.navigate(['../gestorprepago']);

    }
    
  }

  actualizaPDF(nombrearchivo) {
    this.solicitanteService
      .actulizanombreArchivoSolicitante(this.idsolicitudActual, nombrearchivo)
      .subscribe((res) => {
        this.muestrasolicitantesquepagaron(this.aliasusuario);
      });
  }

  elijecliente(listado: Solicitante) {
    this.idusuarioActivo = localStorage.getItem("id");

    this.tablaPescadoresService
      .eleccionRealizadaCliente(listado._id, this.idusuarioActivo)
      .subscribe(
        (seleccionado) => {
          this.procederCaptura = seleccionado;
        },
        (err) => console.log(err)
      );
  }

  visualizaCliente() {
    //  console.log (this.idsolicitante);
    this.editarusuarios(this.idsolicitante);
  }

  enviaemail() {
    let promesa = new Promise<void>((resolve, reject) => {



      setTimeout(() => {
        const nombreArchivocompleto = this.nombreArchivoPDF;
        const subJet = this.subjettxt;
        this.spinner.show();
        const direccionemail = this.txtemail;
        const filepdf = nombreArchivocompleto;
        this.nombreArchivoPDF = filepdf;

        this.emailService
          .sendEmail(direccionemail, filepdf, subJet)
          .subscribe((licen) => {
            this.colorearenglon(this.txtOrdenSolicitud, "#FF4500");
            this.encuentrayactualizapescadoremail(this.idsolicitudActual);

            console.log ('****//////////', this.bprecompra);
            if (this.bprecompra) {



              if (this.registrovienede === "P-AGENCIAS") {

                this.entransitoService
                  .borra(this.txtOrdenSolicitud)
                  .subscribe((archivoborrado) => {
                    this.licenciaentransito(this.idempresa);
                    // aqui llmaremos el emit
                    const payload = {
                      para: this.txtOrdenSolicitud,
                      archivopdf: this.nombreArchivoPDF,
                    };
                    this.socketService.emit("muestrapdf", payload);
                    
                    // actualziaremos ahora a true en pescadores que ya fue enviado
                    // this.encuentrayactualizapescadoremail(this.idsolicitudActual);
                  });


              } else {

                this.entransitoService
                  .borra(this.txtOrdenSolicitud)
                  .subscribe((archivoborrado) => {
                    this.licenciaentransito(this.idempresa);
                    // aqui llmaremos el emit
                    const payload = {
                      para: this.txtOrdenSolicitud,
                      archivopdf: this.nombreArchivoPDF,
                    };
                    this.socketService.emit("muestrapdf", payload);
                    // actualziaremos ahora a true en pescadores que ya fue enviado
                    // this.encuentrayactualizapescadoremail(this.idsolicitudActual);
                  });
              }


            }

            //  this.refrescaInfoSolicitante();
            this.botonrefreshtexto = "Actualiza";
            setTimeout(function () {
              alert("PDF enviado exitosamente")
            }, 3000);


            // this.txtOrdenSolicitud
            // this.botonFinalizadeshabilitado = false;

            // se presionar le boton de refrescar para desaparecer la linea terminada

            //  setTimeout(function(){

            //     },3000);
          });

        resolve();
      }, 1000);
    });

    promesa.then(
      () => {
        this.refrescaSolicitudes = true;

        this.tareafinalizada(this.cveunicasmx, "free");

        console.log("terminado");
      },
      (error) => {
        console.error("onRejected function called: " + error.message);
      }
    );
  }

  devolucionpermisos() {
    let promesadevolucion = new Promise<void>((resolve, reject) => {
      setTimeout(() => {
        if (this.txtOrdenSolicitud != "") {
          //  const session = await
        }

        const nombreArchivocompleto = this.nombreArchivoPDF;
        const subJet = this.subjettxt;
        this.spinner.show();
        const direccionemail = this.txtemail;
        const filepdf = nombreArchivocompleto;
        this.nombreArchivoPDF = filepdf;
        this.emailService
          .sendEmail(direccionemail, filepdf, subJet)
          .subscribe((licen) => {
            this.colorearenglon(this.txtOrdenSolicitud, "#FF4500");

            this.encuentrayactualizapescadoremail(this.idsolicitudActual);

            if (this.bprecompra) {
              this.entransitoService
                .borra(this.txtOrdenSolicitud)
                .subscribe((archivoborrado) => {
                  this.licenciaentransito(this.idempresa);
                  // aqui llmaremos el emit
                  const payload = {
                    para: this.txtOrdenSolicitud,
                    archivopdf: this.nombreArchivoPDF,
                  };
                  this.socketService.emit("muestrapdf", payload);
                  // actualziaremos ahora a true en pescadores que ya fue enviado
                  // this.encuentrayactualizapescadoremail(this.idsolicitudActual);
                });
            }

            //  this.refrescaInfoSolicitante();
            this.botonrefreshtexto = "Actualiza";

            // this.txtOrdenSolicitud
            // this.botonFinalizadeshabilitado = false;

            // se presionar le boton de refrescar para desaparecer la linea terminada

            //  setTimeout(function(){

            //     },3000);
          });

        resolve();
      }, 1000);
    });

    promesadevolucion.then(
      () => {
        console.log("terminado");
      },
      (error) => {
        console.error("onRejected function called: " + error.message);
      }
    );
  }

  encuentrayactualizapescadoremail(identificador: string) {
    this.txtstatusmovimiento = "Procesando...";

    let promesa = new Promise<void>((resolve, reject) => {
      setTimeout(() => {
        this.tablaPescadoresService
          .actualizemail(identificador) // esta opcion unicamente pone en true el envio del reporte pdf en la tabla de pescador
          .subscribe((emailactualizado) => {
            console.log(emailactualizado);
            /** spinner ends after 5 seconds */
            this.listasolicitantes.map((dato) => {
              if (dato.numeroperacion === this.txtOrdenSolicitud) {
                dato.enviadoporemail = true;
              }
            });
          });
        resolve();
      }, 1000);
    });

    promesa.then(
      () => {
        this.spinner.hide();
        this.txtstatusmovimiento = "Listo";
      },
      (error) => {
        this.spinner.hide();
        console.error("onRejected function called: " + error.message);
      }
    );
  }

  refrescaInfoSolicitante() {
    this.contadorsolicitudes = 0;
    this.botonrefreshtexto = "Refrescar";
    this.muestrasolicitantesquepagaron(this.aliasusuario);
  }

  limpiarcomponentes() { }

  editarusuarios(idsolicitante: string) {
    this.usuarioservice
      .LocalizaInfoUsuarios(idsolicitante)
      .subscribe((resp) => {
        this.dialog.open(CapturaComponent, {
          panelClass: "mensaje",
          disableClose: true,
          data: {
            identificador: resp,
          },
        });
      });
  }

  // getMessages() {
  //   return this.wsService.listen('mensaje-nuevo');
  // }

  ultimaprecompra(idempresa: string) {
    console.log("id empresa", idempresa);
    this.precompraService
      .buscaultimaprecompra(idempresa)
      .subscribe((ultimo) => {
        if (ultimo.precompra.length === 0) {
        }
        this.idultimoinventario = ultimo.precompra[0]._id;
        this.inventario = ultimo.precompra[0].inventariototal;
        this.disponibilidad = ultimo.precompra[0].disponibilidad;
        this.muestrainventario(this.idultimoinventario);
        this.numeropaypal = ultimo.precompra[0].refenciapaypal;

        // if (ultimo.pescador[0].idinventarios === ultimo.precompra[0]._id) {
        //   this.cambiacolorcuadro = 'verde';
        // }

        this.precomprasrealizadas = ultimo.solicitudesencontradas.reduce(
          (acc, obj) => acc + obj.cantidad,
          0
        );

        const disponible = this.inventario - this.precomprasrealizadas;

        if (disponible === this.disponibilidad) {
          this.cambiacolordisponiblilidad = "verde";
        }
      });
  }


  ultimaprecompraagencia(idempresa: string, vienede: string) {

    if (vienede.includes('Week') || vienede.includes('Semana')) {
      this.tipolic = "W";
    } else if (vienede.includes('Day') || vienede.includes('Dia')) {
      this.tipolic = "D";
    } else if (vienede.includes('Year') || vienede.includes('Año')) {
      this.tipolic = "Y";
    }

    this.precompraService
      .buscaultimaprecompraagencia(idempresa, this.tipolic)
      .subscribe((ultimo) => {
        if (ultimo.precompra.length === 0) {
        }
        this.idultimoinventario = ultimo.precompra[0]._id;
        this.inventario = ultimo.precompra[0].inventariototal;
        this.disponibilidad = ultimo.precompra[0].disponibilidad;
        this.muestrainventario(this.idultimoinventario);
        this.numeropaypal = ultimo.precompra[0].refenciapaypal;

        // if (ultimo.pescador[0].idinventarios === ultimo.precompra[0]._id) {
        //   this.cambiacolorcuadro = 'verde';
        // }

        this.precomprasrealizadas = ultimo.solicitudesencontradas.reduce(
          (acc, obj) => acc + obj.cantidad,
          0
        );

        const disponible = this.inventario - this.precomprasrealizadas;

        if (disponible === this.disponibilidad) {
          this.cambiacolordisponiblilidad = "verde";
        }
      });
  }

  muestrainventario(idinventario: string) {
    this.tablaPescadoresService
      .getpescadorinventario(idinventario)
      .subscribe((resp: any) => {
        this.enviados = resp.pescador.reduce(
          (acc, obj) => acc + obj.cantidad,
          0
        );
      });
  }

  licenciaentransito(idempresa: string) {
    this.movimientopgoService.listaentransito(idempresa).subscribe((resp) => {
      // this.entransito = resp.entransitomovimiento;
      console.log(resp);
      this.entransito = resp.entransitomovimiento.reduce(
        (acc, obj) => acc + obj.cantidad,
        0
      );
    });
  }



  licenciaentransitoagencia(idempresa: string, tipolic: string) {
    this.movimientopgoService.listaentransitoagencias(idempresa, tipolic).subscribe((resp) => {
      // this.entransito = resp.entransitomovimiento;
      console.log(resp);
      this.entransito = resp.entransitomovimiento.reduce(
        (acc, obj) => acc + obj.cantidad,
        0
      );
    });
  }

  inhabilitalote(listado: Solicitante) {
    this.loteService
      .marcaloteinhabilitado(true, listado._id)
      .subscribe((resp) => {
        console.log("actualizado");
      });
  }


  imprimerecibo() {
    alert('hola');
  }

  seleccionarenglon(listado: Solicitante) {
    const colorrenglon = new Colorenglon(this.colorpersonal);

    this.solicitanteService
      .cambiacolorrenglonsolicitante(listado._id, colorrenglon)
      .subscribe((resp) => {
        const payload = {
          color: this.colorpersonal,
          numerofolio: listado.numeroperacion,
        };

        let valoraceptado = this.rectificapropiedadvalor(
          listado.numeroperacion,
          this.colorpersonal
        );
        if (valoraceptado) {
          this.socketService.emit("colorearenglon", payload);
        }
      });
  }


  //empresaloteslanding


  determinatipolicenciasolicitada() {
    let seleccion: string;

    var promise = new Promise((resolve, reject) => {

      if (this.txtcantidaSolicitada.includes("Dia") || this.txtcantidaSolicitada.includes("Day")) {
        seleccion = "dia"
      } else {

        if (this.txtcantidaSolicitada.includes("Semana") || this.txtcantidaSolicitada.includes("semana")) {
          seleccion = "semana"
        } else {
          if (this.txtcantidaSolicitada.includes("Mes") || this.txtcantidaSolicitada.includes("mes")) {
            seleccion = "mes"
          } else {

            if (this.txtcantidaSolicitada.includes("Año") || this.txtcantidaSolicitada.includes("año")) {
              seleccion = "año"
            } else {
              if (this.txtcantidaSolicitada.includes("Excursion") || this.txtcantidaSolicitada.includes("escursion")) {
                seleccion = "excursion"
              }

            }

          }

        }

      }





      setTimeout(() => {

        resolve(seleccion);
      }, 100);
    });

    promise.then((seleccion) => {
      return seleccion;
    });

















  }





  muestralotelanding(idempresa: string, loteasiganado: number) {
    //this.listadolote=[];
    var seleccionelegida = new Promise((resolve, reject) => {
      let seleccion: string;
      if (this.txtcantidaSolicitada.includes("Dia") || this.txtcantidaSolicitada.includes("Day")) {
        seleccion = "Dia"
      } else {

        if (this.txtcantidaSolicitada.includes("Semana") || this.txtcantidaSolicitada.includes("semana")) {
          seleccion = "Semana"
        } else {
          if (this.txtcantidaSolicitada.includes("Mes") || this.txtcantidaSolicitada.includes("mes")) {
            seleccion = "Mes"
          } else {

            if (this.txtcantidaSolicitada.includes("Año") || this.txtcantidaSolicitada.includes("año")) {
              seleccion = "Año"
            } else {
              if (this.txtcantidaSolicitada.includes("Excursion") || this.txtcantidaSolicitada.includes("escursion")) {
                seleccion = "Excursion"
              }

            }

          }

        }

      }





      setTimeout(() => {

        resolve(seleccion);
      }, 100);






    });







    seleccionelegida.then((seleccion: string) => {
      this.tipolic = seleccion;
      if (loteasiganado == 0 || this.es_usuariosportmx == false) {
        this.loteService.muestralotelanding(idempresa, this.tipolic+"-SMX").subscribe((resp) => {
          this.listadolote = resp.lote;
       //   console.log ('*******************respuestaopcion1', resp.lote);
        });
      } else {
        this.loteService.muestraloteempresabots(idempresa, loteasiganado).subscribe((resp) => {
          this.listadolote = resp.lote;
       //   console.log ('*******************respuestaopcion2');
        });
      }



    });










  }




  muestralotedempresa(idempresa: string, loteasiganado: number) {
    if (loteasiganado == 0 || this.es_usuariosportmx == false) {
      this.loteService.muestraloteempresa(idempresa).subscribe((resp) => {
        this.listadolote = resp.lote;
      });
    } else {
      this.loteService.muestraloteempresabots(idempresa, loteasiganado).subscribe((resp) => {
        this.listadolote = resp.lote;
      });
    }

  }




  muestralotedempresagencia(idempresaseleccion: string) {
    let tipolicsolicitada = ""

    if (this.txtcantidaSolicitada.includes("Dia") || this.txtcantidaSolicitada.includes("Day")) {
      tipolicsolicitada = "Dia"

    } else if (this.txtcantidaSolicitada.includes("Semana") || this.txtcantidaSolicitada.includes("Week")) {
      tipolicsolicitada = "Semana"

    } else if (this.txtcantidaSolicitada.includes("Mes") || this.txtcantidaSolicitada.includes("Month")) {
      tipolicsolicitada = "Mes"

    } else if (this.txtcantidaSolicitada.includes("Año") || this.txtcantidaSolicitada.includes("Year")) {
      tipolicsolicitada = "Año"

    }


    //  if (loteasiganado == 0 || this.es_usuariosportmx==false) {
    this.loteService.muestraloteempresagencia(idempresaseleccion, tipolicsolicitada).subscribe((resp) => {
      this.listadolote = resp.lote;
      //  });
      //   } else {
      //   this.loteService.muestraloteempresabots("5fcbc46994dde809f8aab6cc",loteasiganado ).subscribe((resp) => {
      //   this.listadolote = resp.lote;
      // });
    })

  }



  muestralotedempresavarios(tipoempresa: string) {
    if (this.txtcantidaSolicitada.includes("Excursion")) {
      tipoempresa = "Excursion";
    } else {
      if (this.txtcantidaSolicitada.includes("Año")) {
        tipoempresa = "año";
      } else {
        tipoempresa = "semana";
      }
    }

    this.loteService.muestraloteempresavarios(tipoempresa).subscribe((resp) => {
      console.log("********************" + resp.lote)
      this.listadolote = resp.lote;
    });
  }







  muestralotedempresavariasagencias(tipoempresa: string) {
    if (this.txtcantidaSolicitada.includes("Excursion")) {
      tipoempresa = "Excursion";
    } else {
      if (this.txtcantidaSolicitada.includes("Año")) {
        tipoempresa = "año";
      } else {
        tipoempresa = "semana";
      }
    }

    this.loteService.muestraloteempresavarios(tipoempresa).subscribe((resp) => {
      console.log("********************" + resp.lote)
      this.listadolote = resp.lote;
    });
  }




  


  myTabSelectedTabChange(changeEvent: MatTabChangeEvent) {
    console.log('Index: ' + changeEvent.index);
    if (changeEvent.index == 1) {
      this.displayhistorial = true;
    } else {
      this.displayhistorial = false;
    }
  }  


  detectacambios() {
    console.log ("entro")
  }

  cambiaestadoBots(){
    this.botsActivos = !this.botsActivos
   // console.log (this.botsActivos);

   if (this.botsActivos) {

   } else {
    
   }
  }

}
